import { Inject, Injectable } from 'angular-ts-decorators';

export interface IPfmLoadQueueService {
  add(name: string): void;
  isEmpty(): boolean;
  remove(name: string): void;
}

@Injectable('pfmLoadQueue')
export class PfmLoadQueueService implements IPfmLoadQueueService {
  public static $inject: ReadonlyArray<string> = ['$log'];

  private queue: string[];

  constructor(@Inject('$log') private $log: ng.ILogService) {
    this.queue = [];
  }

  public add(name: string): void {
    if (!name) {
      this.$log.warn('Provided queue item name is not a string or empty.');
      return;
    }

    if (this.queue.indexOf(name) > -1) {
      this.$log.warn('Provided queue item name is already present in queue. ', name);
      return;
    }

    this.$log.info('Adding queue item. ', name);
    this.queue.push(name);
  }

  public isEmpty(): boolean {
    return this.queue.length === 0;
  }

  public remove(name: string): void {
    let queueItemIndex: number;

    if (!name) {
      this.$log.warn('Provided queue item name is not a string or empty.');
      return;
    }

    queueItemIndex = this.queue.indexOf(name);
    if (queueItemIndex === -1) {
      this.$log.warn('Provided queue item name is not present in queue. ', name);
      return;
    }

    this.$log.info('Removing queue item. ', name);
    this.queue.splice(queueItemIndex, 1);
  }
}
